import React, { useEffect, useState } from "react"
import Typography from "aldoo-ra/Typography"
import DropdownSelect from "aldoo-ra/DropdownSelect"
import { listOrgs } from "aldoo-ra/Organizations/api"
import ProjectList from "@components/aldoo-status/Projects/ProjectList"

const ProjectsSection = () => {
  const [orgs, setOrgs] = useState([])
  const [selectedOrg, setSelectedOrg] = useState(null)

  useEffect(() => {
    (async () => {
      const r = await listOrgs()
      const list = r?.orgs || r?.organizations || r?.list || []
      setOrgs(list)
      if (list.length && !selectedOrg) {
        const first = list[0]
        setSelectedOrg({ value: String(first._id), label: first.name })
      }
    })()
  }, [])

  if (!orgs.length) {
    return <div className="text-admin_muted">Create an organization first under <b>Organizations</b>.</div>
  }

  const options = orgs.map((o) => ({ value: String(o._id), label: o.name }))

  return (
    <div className="space-y-4">
      <div className="max-w-sm">
        <DropdownSelect label="Organization" value={selectedOrg} onChange={(v) => setSelectedOrg(v?.[0] || v)} options={options} />
      </div>
      {selectedOrg?.value && <ProjectList orgId={selectedOrg.value} />}
    </div>
  )
}

export default ProjectsSection
